module.exports = __webpack_public_path__ + "static/media/child1.7398ceef.webp";